// import $ from 'jquery';

$(() => {
	const $element = $('#currentYear');
	if ($element && $element.length > 0) {
		$element.html(new Date().getFullYear());
	}
});


// WEBPACK FOOTER //
// ./client/src/site__fus078/components/current-year/index.js